import axios from 'axios'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions'

export default function excluirPontoEmbarque(id) {
  const url = `${URL}/ponto-embarque/${id}`
  return () => axios.delete(url, SLOW_REQUEST_CONFIG)
}
